import React from 'react'
import { SvgIconProps } from '../Icon.types'

export const InfoOutline: React.FC<SvgIconProps> = ({
  width = 24,
  height = 24,
  fill = 'currentColor',
  title = '',
  className,
  ...props
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 24 24'
      fill='none'
      className={className}
      aria-hidden={!title}
      focusable='false'
      {...props}
    >
      {title && <title>{title}</title>}
      <path
        d='M21.25 12C21.25 6.89137 17.1086 2.75 12 2.75C6.89136 2.75 2.75 6.89136 2.75 12C2.75 17.1086 6.89137 21.25 12 21.25C17.1086 21.25 21.25 17.1086 21.25 12ZM22.75 12C22.75 17.937 17.937 22.75 12 22.75C6.06293 22.75 1.25 17.937 1.25 12C1.25 6.06294 6.06294 1.25 12 1.25C17.937 1.25 22.75 6.06293 22.75 12Z'
        fill={fill}
      />
      <path
        d='M11.4922 17V12C11.4922 11.9008 11.4914 11.8205 11.4902 11.751C11.421 11.7499 11.3409 11.75 11.2422 11.75C10.828 11.75 10.4922 11.4142 10.4922 11C10.4922 10.5858 10.828 10.25 11.2422 10.25C11.4567 10.25 11.6929 10.2488 11.8906 10.2754C12.0826 10.3012 12.3214 10.362 12.5361 10.5352L12.626 10.6162L12.707 10.7061C12.8801 10.9207 12.941 11.1595 12.9668 11.3516C12.9934 11.5493 12.9922 11.7855 12.9922 12V17C12.9922 17.4142 12.6564 17.75 12.2422 17.75C11.828 17.75 11.4922 17.4142 11.4922 17Z'
        fill={fill}
      />
      <path
        d='M12.0008 7.25L12.0779 7.25391C12.456 7.29243 12.7508 7.61176 12.7508 8C12.7508 8.38824 12.456 8.70757 12.0779 8.74609L12.0008 8.75H11.992C11.5778 8.75 11.242 8.41421 11.242 8C11.242 7.58579 11.5778 7.25 11.992 7.25H12.0008Z'
        fill={fill}
      />
    </svg>
  )
}

export default InfoOutline
